import { DiagonalCornerState } from './diagonalCorner.types';

import { RootState } from '~/redux/store';

export const selectSelectedDiagonalCorner = ({
  diagonalCorner,
}: RootState): DiagonalCornerState['selectedDiagonalCorner'] =>
  diagonalCorner.selectedDiagonalCorner;
